import { selectByTypeCodes } from '@/services/public';

export default {
  namespace: 'public',
  state: {
    // 字典数据
    directives: [],
  },
  effects: {
    *getDictData({ payload }, { call, put }) {
      try {
        const response = yield call(selectByTypeCodes, payload);
        let directives = response?.data ?? [];
        if ((response && response.code === 1) || response.code === 200) {
          yield put({
            type: 'update',
            payload: {
              directives: directives,
            },
          });
        } else {
          // 这里可以添加对非成功状态码的处理，例如通知用户
          console.error('Failed to fetch dictionary data:', response);
          // 你可能想在此处触发一个全局错误通知
        }
      } catch (error) {
        console.error('An error occurred while fetching dictionary data:', error);
        // 这里可以发送一个失败的 action 来更新 state，或者通知用户
        yield put({
          type: 'errorOccured',
          payload: {
            error: 'An error occurred while fetching data',
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    // 添加一个错误处理的 reducer
    errorOccured(state, { payload }) {
      // 这里可以将错误信息存入state，也可以不修改state
      return { ...state, errorMessage: payload.error };
    },
  },
};
